import { GetTransferOrder_Out } from 'src/pehra-ts-client';
import styles from './TransferOrderList.module.css';
import { GridColDef } from '@mui/x-data-grid';
import { Box, Button, Typography } from '@mui/material';
import AppStripedDataGrid from 'src/components/AppStripedDataGrid';
import { TransferOrdersService } from 'src/pehra-ts-client';
import { useState } from 'react';
import Papa from 'papaparse';

export interface ITransferOrderList {
  rows: GetTransferOrder_Out[] | undefined;
}

const TransferOrderList: React.FC<ITransferOrderList> = ({ rows }) => {
  const [selectedRows, setSelectedRows] = useState<any>([]);

  const fetchCsv = async (id: string): Promise<any[]> => {
    const response = await TransferOrdersService.getTransferOrder(id);
    const text = response;
    return new Promise((resolve, reject) => {
      Papa.parse(text, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => resolve(results.data),
        error: (error: any) => reject(error)
      });
    });
  };

  const handleDownloadFileClick = async (id: string) => {
    try {
      const res = await TransferOrdersService.getTransferOrder(id);
      let filename = 'out.csv';
      const text = await res; // Get the response text
      const blob = new Blob([text], { type: 'text/csv' }); // Create a Blob from the text

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log(error);
    }
  };

  const columns: GridColDef[] = [
    {
      field: 'Created at',
      headerClassName: 'table--header',
      headerName: 'Creation Time',
      flex: 1,
      renderCell: (params: any) => {
        return <Box className={styles.rowDiv}>{new Date(params.row.creation_time).toLocaleString()}</Box>;
      }
    },
    {
      field: 'Office',
      headerClassName: 'table--header',
      headerName: 'Office',
      flex: 1,
      renderCell: (params: any) => {
        return params.row.office && <Box className={styles.rowDiv}>{params.row.office.name}</Box>;
      }
    },
    {
      field: 'Employees',
      headerClassName: 'table--header',
      headerName: 'Employees',
      flex: 1,
      renderCell: (params: any) => {
        return <Box className={styles.rowDiv}>{params.row.employees.map((employee: any) => employee.name).join(', ')}</Box>;
      }
    },
    {
      field: 'Action',
      headerClassName: 'table--header',
      headerName: '',
      flex: 1,
      renderCell: (params: any) => {
        return (
          <Box className={styles.rowDiv}>
            <Button
              variant="outlined"
              onClick={() => {
                handleDownloadFileClick(params.row.id);
              }}
            >
              Download File
            </Button>
          </Box>
        );
      }
    }
  ];

  const handleSelectionChange = (selectionModel: any) => {
    setSelectedRows(selectionModel);
  };
  const convertToCsv = (headers: string[], records: any[]): string => {
    const headerRow = headers.join(',');
    const dataRows = records.map((record) => headers.map((header) => JSON.stringify(record[header] || '')).join(','));
    return [headerRow, ...dataRows].join('\n');
  };
  const handleTransferOrderMerge = async () => {
    const records: any[] = [];
    let headersSet = false;
    let headers: string[] = [];

    for (const id of selectedRows) {
      const fileRecords = await fetchCsv(id);
      if (!headersSet && fileRecords.length > 0) {
        headers = Object.keys(fileRecords[0]);
        headersSet = true;
      }
      records.push(...fileRecords);
    }
    const text = convertToCsv(headers, records);
    const blob = new Blob([text], { type: 'text/csv' });
    const filename = 'out.csv';
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    a.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <Box className={styles.container}>
      <Box
        sx={{
          marginTop: '10px',
          marginBottom: '10px',
          background: 'transparent'
        }}
      >
        {selectedRows.length > 0 && (
          <Box className={styles.selectedRowsActionContainer}>
            <Typography variant="h6" className={styles.selectedRowsTitle}>
              {selectedRows.length} Selected
            </Typography>
            <Button
              variant="outlined"
              onClick={() => {
                handleTransferOrderMerge();
              }}
            >
              Merge and Download Orders
            </Button>
          </Box>
        )}
      </Box>{' '}
      <AppStripedDataGrid
        autoHeight
        columns={columns}
        getRowId={(row: any) => row.id}
        rows={rows || []}
        style={{
          width: '100%'
        }}
        checkboxSelection
        onRowSelectionModelChange={(newSelection: any) => {
          handleSelectionChange(newSelection);
        }}
      />
    </Box>
  );
};

export default TransferOrderList;
